import { Price } from "@/components/Price/price";

type ProductBundlePriceComponentProps = {
    salesPrice: number;
    strikethroughPrice?: number;
    className?: string;
};

const ProductBundlePriceComponent = ({
    salesPrice,
    strikethroughPrice,
    className
}: ProductBundlePriceComponentProps) => (
    <Price
        className={className}
        price={salesPrice}
        strikeThroughPrice={strikethroughPrice}
        size={"md"}
    >
        {strikethroughPrice && <Price.StrikeThrough />}
        <Price.Main />
    </Price>
);

export { ProductBundlePriceComponent };
